const getUrlParameters = (parameter) => {
  const url = window.location.search;
  const urlParams = new URLSearchParams(url);
  // Return all parameters in the URL if no specific query is passed
  if (!parameter) {
    const entries = urlParams.entries();
    const data = {};
    for (const entry of entries) {
      data[entry[0]] = entry[1];
    }
    return data;
  }
  const matchingParameter = urlParams.get(parameter);
  return matchingParameter;
};

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN'
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', {bubbles: true});

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {'Content-Type': 'application/json', Accept: `application/${type}`}
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.drawerCloseToggle = this.querySelector('.drawer-close');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.js-button)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
    // P80 - custom close class to get the close drawer function
    if (this.drawerCloseToggle) this.drawerCloseToggle.addEventListener('click', this.closeMenuDrawer.bind(this));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.sliderFirstItemNode = this.slider.querySelector('.slider__slide');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    if (this.sliderControlWrapper === null) return;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        })
      );
    }

    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.updateSliderControlButtons(this.currentPage);

    if (this.enableSliderLooping) return;

    if (!this.prevButton) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (!this.nextButton) return;

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  updateSliderControlButtons(currentIndex) {
    if (!this.sliderControlButtons.length) return;
    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    if (!currentIndex) return;
    this.sliderControlButtons[currentIndex - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[currentIndex - 1].setAttribute('aria-current', true);
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    // p80 - Upsell variant radios to update the image
    const variantImages = this.closest('.product').querySelectorAll('.card-variant-image');
    if (variantImages) {
      variantImages.forEach((image) => {
        const variantImageId = Number(image.dataset.imageId);
        image.classList.remove('card-variant-image--active');
        if (variantImageId === this.currentVariant.id) {
          image.classList.add('card-variant-image--active');
        }
      });
    }

    // p80 - don't run below script if we have a variant picker on cart upsell.
    if (this.classList.contains('variant-picker-upsell')) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #cart-upsell-${this.dataset.section}-${this.dataset.productId}`
    ); // p80- Added cart-upsell id
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', {bubbles: true}));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = this.closest('.product').querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        if (source && destination) destination.innerHTML = source.innerHTML;

        const radios = html.querySelector(
          `variant-radios[data-section=${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          }]`
        );
        const radioDestination = document.querySelector(`variant-radios[data-section=${this.dataset.section}]`);
        if (radios && radioDestination) radioDestination.innerHTML = radios.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

        const variantName = html.getElementById(
          `variant-name-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const variantNameDestination = document.getElementById(
          `variant-name-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        if (variantName && variantNameDestination) {
          variantNameDestination.innerHTML = variant.innerHTML;
        }
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #cart-upsell-${this.dataset.section}-${this.dataset.productId}`
    );
    if (!productForms) return;
    productForms.forEach((productForm) => {
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
      if (!addButton) return;

      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        // p80 - remove class disable to fix layout flash
        addButton.classList.remove('button--disabled');
        addButtonText.textContent = window.variantStrings.addToCart;
      }

      // p80 - add class disable to fix layout flash
      if (!this.currentVariant || !this.currentVariant.available) {
        addButton.classList.add('button--disabled');
        addButtonText.textContent = window.variantStrings.soldOut;
      }
    });
    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slider-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px'
    }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

if (typeof p80 === typeof undefined) {
  var p80 = {};
}

p80.updateCartCount = (count) => {
  const icons = document.querySelectorAll('[data-cart-quantity]');
  if (!icons) return;
  for (var x = 0; x < icons.length; x++) {
    const countIcon = icons[x].querySelector('.cart-count-bubble');
    if ((count <= 0 && countIcon) || (!count && countIcon)) {
      countIcon.remove();
    } else if (count && countIcon) {
      const labels = countIcon.querySelectorAll('span');
      for (var y = 0; y < labels.length; y++) {
        labels[y].textContent = count;
      }
    } else if (count && !countIcon) {
      const wrapper = document.createElement('div');
      wrapper.classList.add('cart-count-bubble');
      const aria = document.createElement('span');
      aria.setAttribute('aria-hidden', true);
      aria.innerText = count;
      const text = document.createElement('span');
      text.classList.add('visually-hidden');
      text.innerText = count;
      wrapper.appendChild(aria);
      wrapper.appendChild(text);
      icons[x].appendChild(wrapper);
    }
  }
};

class ShippingBar extends HTMLElement {
  constructor() {
    super();
    // The current shop currency
    this.currency = this.getAttribute('data-currency');
    // Free shipping threshold has not been met messaging
    this.freeShippingPending = this.querySelector('[data-free-shipping-pending]');
    // The current cart total within the pending messaging
    this.freeShippingPendingTotal = this.freeShippingPending
      ? this.freeShippingPending.querySelector('[data-amount]')
      : null;
    // Free shipping threshold has been met messaging
    this.freeShippingMet = this.querySelector('[data-free-shipping-met]');
    // The progress bar
    this.progress = this.querySelector('progress');
    // The free shipping threshold
    this.threshold = this.getAttribute('data-threshold');
    if (this.threshold) this.threshold = parseInt(this.threshold, 10);
    // The total price of the cart
    this.cartTotal = this.getAttribute('data-total');
    if (this.cartTotal) this.cartTotal = parseInt(this.cartTotal, 10);

    // Immediately generate markup if we have the available data via liquid
    this.updateShipping();

    // Listen to broadcasted cart change event for use in multiple scenarios
    document.addEventListener(
      'cartChange',
      (e) => {
        if (!e || !e.detail || !e.detail.cartTotal) return;
        this.cartTotal = e.detail.cartTotal;
        this.updateShipping();
      },
      false
    );
  }

  updateShipping() {
    if (!this.threshold) return;
    if (!this.cartTotal) {
      let defaultPrice = this.threshold;
      defaultPrice = defaultPrice / 100;
      defaultPrice = defaultPrice.toLocaleString('en-US', {
        style: 'currency',
        currency: this.currency
      });
      if (this.freeShippingPendingTotal) this.freeShippingPendingTotal.textContent = defaultPrice;
      return;
    }
    // Display appropriate messaging
    if (this.cartTotal >= this.threshold) {
      if (this.freeShippingPending) this.freeShippingPending.classList.add('hidden');
      if (this.freeShippingMet) this.freeShippingMet.classList.remove('hidden');
    } else {
      if (this.freeShippingPending) this.freeShippingPending.classList.remove('hidden');
      if (this.freeShippingMet) this.freeShippingMet.classList.add('hidden');
    }
    // Update the progress bar
    if (this.progress) this.progress.setAttribute('value', this.cartTotal);
    // Update the threshold offset messaging
    if (this.freeShippingPendingTotal) this.freeShippingPendingTotal.textContent = this.formatThreshold();
  }

  formatThreshold() {
    if (!this.cartTotal || !this.currency) return;
    let price = this.threshold - this.cartTotal;
    if (price < 0) price = 0;
    price = price / 100;
    price = price.toLocaleString('en-US', {style: 'currency', currency: this.currency});
    return price;
  }
}

customElements.define('shipping-bar', ShippingBar);

class AccordionComponent extends HTMLElement {
  constructor() {
    super();

    // The toggle button
    this.toggle = this.querySelector('[data-toggle]');
    // The content body
    this.content = this.querySelector('[data-content]');
    // Other accordions within the same container
    this.siblings = this.parentElement.querySelectorAll('accordion-component');
    // Holds our open/closed state
    this.expanded = false;
    this.timer = null;

    if (!this.toggle || !this.content) return;

    this.toggle.addEventListener('click', this.toggleAccordion.bind(this));
  }

  toggleAccordion(event) {
    if (event) event.preventDefault();
    clearTimeout(this.timer);
    if (this.expanded) {
      this.closeAccordion();
    } else {
      this.closeSiblings();
      this.openAccordion();
    }
  }

  openAccordion() {
    this.expanded = true;
    this.classList.add('accordion__item--open');
    this.toggle.setAttribute('aria-expanded', true);
    this.content.setAttribute('aria-hidden', false);
    this.content.style.height = this.content.scrollHeight + 'px';
    this.timer = setTimeout(() => {
      this.content.style.height = 'auto';
    }, 350);
  }

  closeAccordion() {
    this.expanded = false;
    this.content.style.height = this.content.scrollHeight + 'px';
    this.timer = setTimeout(() => {
      this.content.style.height = null;
    }, 0);
    this.classList.remove('accordion__item--open');
    this.toggle.setAttribute('aria-expanded', false);
    this.content.setAttribute('aria-hidden', true);
  }

  closeSiblings() {
    if (!this.siblings || !this.siblings.length) return;

    for (var x = 0; x < this.siblings.length; x++) {
      if (this.siblings[x] === this || this.siblings[x].expanded === false) continue;
      this.siblings[x].closeAccordion();
    }
  }
}

customElements.define('accordion-component', AccordionComponent);

class HotspotAccordionComponent extends AccordionComponent {
  constructor() {
    super();
    this.index = this.getAttribute('data-index');
    this.siblings = this.parentElement.querySelectorAll('hotspot-accordion-component');
    this.bind();
  }

  bind() {
    this.toggle.addEventListener('click', this.toggleHotspot.bind(this));
  }

  toggleHotspot() {
    if (!this.index) return;
    const parent = this.closest('.hotspot-image');
    if (!parent) return;
    const hotspots = parent.querySelectorAll('hotspot-button');
    if (!hotspots.length) return;
    hotspots.forEach((hotspot) => {
      if (hotspot.getAttribute('data-index') === this.index && this.expanded) {
        hotspot.activate();
      } else {
        hotspot.deactivate();
      }
    });
  }
}

customElements.define('hotspot-accordion-component', HotspotAccordionComponent);

class MegaMenu extends HTMLElement {
  constructor() {
    super();
    this.headerWrapper = this.closest('.header-wrapper');
    this.megaMenuItem = this.querySelector('.mega-menu__item');
    this.addEventListener('focusin', this.onFocusIn.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    if (this.headerWrapper) {
      this.addEventListener('mouseover', this.onMouseOver.bind(this));
      this.addEventListener('mouseout', this.onMouseOut.bind(this));
    }
  }

  onMouseOver() {
    this.megaMenuActive();
  }

  onMouseOut() {
    this.megaMenuInactive();
    this.close();
  }

  onFocusIn() {
    this.open();
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  open() {
    this.classList.add('mega-menu--open');
    this.megaMenuItem.setAttribute('aria-expanded', true);
    this.megaMenuActive();
  }

  close() {
    this.classList.remove('mega-menu--open');
    this.megaMenuItem.setAttribute('aria-expanded', false);
    this.megaMenuInactive();
  }

  megaMenuActive() {
    this.headerWrapper.classList.add('header-wrapper--mega-menu-open');
    document.body.classList.add('mega-menu-open');
  }

  megaMenuInactive() {
    this.headerWrapper.classList.remove('header-wrapper--mega-menu-open');
    document.body.classList.remove('mega-menu-open');
  }
}

customElements.define('mega-menu', MegaMenu);

class TabComponent extends HTMLElement {
  constructor() {
    super();
    this.tabFocus = 0;
    const tabs = this.querySelectorAll('[role="tab"]');
    const tabList = this.querySelector('[role="tablist"]');

    if (!tabs && !tabList) return;

    tabs.forEach((tab) => {
      tab.addEventListener('click', this.handleEvent.bind(this));
    });
    tabList.addEventListener('keydown', this.onKeyDown.bind(this));
  }

  handleEvent(event) {
    if (!event) return;
    const tab = event.target;
    const tabList = event.target.parentNode;
    const container = tabList ? tabList.parentNode : null;
    const tabPanel = container ? container.querySelector(`#${tab.getAttribute('aria-controls')}`) : null;
    if (!tab || !tabList || !container || !tabPanel) return;

    tabList.querySelectorAll('[aria-selected="true"]').forEach((menu) => {
      menu.setAttribute('aria-selected', false);
    });
    container.querySelectorAll('[role="tabpanel"]').forEach((panel) => {
      panel.classList.remove('is-visible', 'is-faded');
    });

    tab.setAttribute('aria-selected', true);
    tabPanel.classList.add('is-visible');
    tabPanel.offsetHeight;
    tabPanel.classList.add('is-faded');
  }

  onKeyDown(event) {
    if (event.code === 'ArrowRight' || event.code === 'ArrowLeft') {
      const tabs = event.target.parentNode.children;

      if (!tabs[this.tabFocus]) return;

      tabs[this.tabFocus].setAttribute('tabindex', -1);
      tabs[this.tabFocus].setAttribute('aria-selected', false);

      if (event.code === 'ArrowRight') {
        this.tabFocus++;
        if (this.tabFocus >= tabs.length) {
          this.tabFocus = 0;
        }
      }

      if (event.code === 'ArrowLeft') {
        this.tabFocus--;
        if (this.tabFocus < 0) {
          this.tabFocus = tabs.length - 1;
        }
      }

      tabs[this.tabFocus].setAttribute('tabindex', 0);
      tabs[this.tabFocus].setAttribute('aria-selected', true);
      tabs[this.tabFocus].focus();
    }
  }
}

customElements.define('tab-component', TabComponent);

class FindYourWetsuit extends HTMLElement {
  constructor() {
    super();
    this.data = [];
    this.feetInput = this.querySelector(`[name='feet']`);
    this.inchesInput = this.querySelector(`[name='inches']`);
    this.weightInput = this.querySelector(`[name='weight']`);
    this.genderInputs = this.querySelectorAll(`[name='gender']`);
    this.collectionURL = this.getAttribute('data-collection-url');
    this.submitButton = this.querySelector('button');
    if (!this.feetInput || !this.inchesInput || !this.weightInput || !this.genderInputs.length || !this.submitButton) {
      console.info('Required markup not found.');
      return;
    }
    if (!this.collectionURL) {
      console.info('Collection URL Missing.');
      return;
    }
    this.genderInputs.forEach((input) => {
      if (input.checked === true) this.gender = input.value;
    });
    this.weightRanges = {
      Mens: [
        '121-143',
        '130-143',
        '121-157',
        '121-157',
        '158-161',
        '158-164',
        '161-179',
        '160-175',
        '121-175',
        '176-180',
        '176-195',
        '176-182',
        '191',
        '188-215',
        '207-235',
        '229-230',
        '230-285'
      ],
      Womens: [
        '98-112',
        '108-112',
        '98-120',
        '98-121',
        '98-131',
        '118-132',
        '98-141',
        '140-167',
        '139-141',
        '134-149',
        '150-167',
        '145-154',
        '145-164',
        '165',
        '166-184',
        '185-190',
        '191-235'
      ]
    };
    this.heightRanges = {
      Mens: [
        '149-161',
        '157-163',
        '149-173',
        '172-183',
        '149-171',
        '172-183',
        '149-181',
        '180-186',
        '185-201',
        '149-176',
        '149-201',
        '182-191',
        '175-191',
        '149-201',
        '149-201',
        '170-183',
        '149-201'
      ],
      Womens: [
        '142-155',
        '149-155',
        '142-158',
        '142-163',
        '142-171',
        '142-171',
        '142-183',
        '142-171',
        '177-181',
        '165-183',
        '170-176',
        '177-181',
        '177-183',
        '172-183',
        '142-183',
        '149-176',
        '142-183',
        '142-183'
      ]
    };
    this.bind();
  }

  bind() {
    this.feetInput.addEventListener(
      'keyup',
      debounce(() => {
        this.onKeyUp();
      }, 300).bind(this)
    );
    this.inchesInput.addEventListener(
      'keyup',
      debounce(() => {
        this.onKeyUp();
      }, 300).bind(this)
    );
    this.weightInput.addEventListener(
      'keyup',
      debounce(() => {
        this.onKeyUp();
      }, 300).bind(this)
    );
    this.genderInputs.forEach((input) => {
      input.addEventListener('change', (e) => {
        this.gender = input.value;
      });
    });
    this.submitButton.addEventListener('click', this.onSubmit.bind(this));
  }

  onSubmit() {
    if (!this.feetValue || !this.inchesValue || !this.weightValue || !this.gender) return;
    const redirect = this.generateRedirect();
    if (!redirect) return;
    window.location.href = redirect;
  }

  onKeyUp() {
    this.feetValue = this.feetInput.value;
    this.inchesValue = this.inchesInput.value;
    this.weightValue = this.weightInput.value;
  }

  generateRedirect() {
    const heightRanges = this.heightRanges[this.gender];
    const weightRanges = this.weightRanges[this.gender];
    const metricHeight = this.imperialToMetric(this.feetValue, this.inchesValue);
    if (!weightRanges || !weightRanges.length || !heightRanges || !heightRanges.length || !metricHeight) return;

    let matchingHeights = [];
    for (var x = 0; x < heightRanges.length; x++) {
      const values = heightRanges[x].split('-');
      if (
        (values[0] && values[1] && metricHeight >= values[0] && metricHeight <= values[1]) ||
        metricHeight === values[0]
      ) {
        matchingHeights.push(heightRanges[x]);
        break;
      }
    }
    let matchingWeights = [];
    for (var x = 0; x < weightRanges.length; x++) {
      const values = weightRanges[x].split('-');
      if (
        (values[0] &&
          values[1] &&
          this.weightValue >= parseInt(values[0], 10) &&
          this.weightValue <= parseInt(values[1], 10)) ||
        this.weightValue === parseInt(values[0], 10)
      ) {
        matchingWeights.push(weightRanges[x]);
        break;
      }
    }
    if (!matchingWeights.length || !matchingHeights.length)
      return `${this.collectionURL}?originalWeight=${this.weightValue}&originalFeet=${this.feetValue}&originalInches=${this.inchesValue}`;
    const redirectGender = this.gender === 'Mens' ? 'Mens' : 'Womens';
    let heightString = '';
    matchingHeights.forEach((height) => {
      heightString = heightString += `&filter.v.m.p80.heightRanges=${height}`;
    });
    let weightString = '';
    matchingWeights.forEach((weight) => {
      weightString = weightString += `&filter.v.m.p80.weightRanges=${weight}`;
    });
    const redirect = `${this.collectionURL}?filter.v.m.p80.gender=${redirectGender}${heightString}${weightString}&view=wetsuit-finder&originalWeight=${this.weightValue}&originalFeet=${this.feetValue}&originalInches=${this.inchesValue}`;
    return redirect;
  }

  imperialToMetric(feet, inches) {
    if (!feet || !inches) return;
    const metricHeight = feet * 30.48 + inches * 2.54;
    return metricHeight;
  }
}

customElements.define('find-your-wetsuit', FindYourWetsuit);

class FindYourSize extends HTMLElement {
  constructor() {
    super();
    this.data = [];
    this.queryFeet = getUrlParameters('originalFeet');
    this.queryInches = getUrlParameters('originalInches');
    this.queryWeight = getUrlParameters('originalWeight');
    this.queryGender = getUrlParameters('filter.v.m.p80.gender');
    this.defaultGender = this.getAttribute('data-default-gender');
    this.feetInput = this.querySelector('[data-height-feet]');
    this.inchesInput = this.querySelector('[data-height-inches]');
    this.lbsInput = this.querySelector('[data-weight-lbs]');
    this.genderInputs = this.querySelectorAll('[data-gender-select]');
    this.chartSelect = this.querySelector('[data-chart-select]');
    this.chartUrl = this.getAttribute('data-chart-url');
    this.chartContainer = this.querySelector('[data-chart-container]');
    this.sizeText = this.parentElement.querySelector('[data-size-text]');
    this.submitButton = this.querySelector('[data-search]');
    this.allChartMarkup = null;
    this.errorMessage = this.querySelector('[data-error]');
    this.disabled = false;
    if (!this.feetInput || !this.inchesInput || !this.lbsInput || !this.genderInputs.length || !this.submitButton) {
      console.info('Required markup not found.');
      return;
    }

    if (this.queryFeet && this.queryInches && this.queryWeight && this.queryGender) {
      this.setDefaults();
    } else {
      this.genderInputs.forEach((input) => {
        if (this.defaultGender && this.defaultGender == input.value) {
          this.gender = input.value;
          input.checked = true;
        } else if (!this.defaultGender) {
          if (input.checked === true) this.gender = input.value;
        }
      });
      this.generateData();
    }

    const defaultValue =
      this.chartSelect && this.chartSelect.querySelector('select')
        ? this.chartSelect.querySelector('select').value
        : '';
    if (defaultValue != '' && defaultValue != 'size-chart-wetsuits') {
      this.displayChart = defaultValue;
      this.fetchChart();
    }

    this.bind();
  }

  setDefaults() {
    this.feetInput.value = this.queryFeet;
    this.feetValue = this.feetInput.value;
    this.inchesInput.value = this.queryInches;
    this.inchesValue = this.inchesInput.value;
    this.lbsInput.value = this.queryWeight;
    this.lbsValue = this.lbsInput.value;
    this.gender = this.queryGender;

    this.generateData();

    this.genderInputs.forEach((input) => {
      if (input.value == this.queryGender) {
        input.checked = true;
        this.activeRow = [];
      } else {
        input.checked = false;
      }
    });

    this.updateFits();
    this.findMatch();
  }

  generateData() {
    this.tables = this.querySelectorAll(`[data-gender]`);
    if (!this.tables.length) {
      console.info('Required markup not found.');
      return;
    }
    this.tables.forEach((table) => {
      const gender = table.getAttribute('data-gender');
      if (gender == this.gender) {
        this.table = table;
        this.table.classList.remove('hidden');
      } else {
        table.classList.add('hidden');
      }
    });
    if (!this.table) return;
    this.rows = this.table.querySelectorAll(`.size-chart__grid-item:not(.size-chart__label):not(.size-chart__unit)`);
    if (!this.rows.length) {
      console.info('Required markup not found.');
      return;
    }
    this.loader = this.table.querySelector('[data-loader]');
  }

  bind() {
    const chart = this;
    this.feetInput.addEventListener(
      'keyup',
      debounce(() => {
        this.onKeyUp();
      }, 400).bind(this)
    );
    this.inchesInput.addEventListener(
      'keyup',
      debounce(() => {
        this.onKeyUp();
      }, 400).bind(this)
    );
    this.lbsInput.addEventListener(
      'keyup',
      debounce(() => {
        this.onKeyUp();
      }, 400).bind(this)
    );
    this.submitButton.addEventListener('click', function () {
      if (chart.feetValue && chart.inchesValue && chart.lbsValue) chart.findMatch();
    });
    this.genderInputs.forEach((input) => {
      input.addEventListener('change', (e) => {
        chart.gender = input.value;
        this.activeRow = [];
        this.generateData();
        this.updateFits();
        this.findMatch();
      });
    });
    if (this.chartSelect) {
      this.chartSelect.addEventListener('change', function (e) {
        chart.displayChart = e.target.value;
        chart.fetchChart();
      });
    }
  }

  fetchChart() {
    if (!this.chartContainer || !this.chartUrl) return;
    if (
      (this.allChartMarkup && this.allChartMarkup.length) ||
      this.displayChart == 'size-chart-wetsuits' ||
      this.displayChart == ''
    ) {
      this.renderChart();
      return;
    }
    if (this.loader) this.loader.classList.remove('hidden');
    fetch(Shopify.routes.root + `pages/${this.chartUrl}`)
      .then((response) => response.text())
      .then((data) => {
        const html = new DOMParser().parseFromString(data, 'text/html');
        html && html.querySelector('.find-your-size')
          ? (this.allChartMarkup = html.querySelectorAll('.find-your-size .find-your-size__chart'))
          : null;
        this.renderChart();
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if (this.loader) this.loader.classList.add('hidden');
        if (this.errorMessage) this.errorMessage.classList.add('hidden');
      });
  }

  renderChart() {
    if (!this.chartContainer || !this.allChartMarkup || this.displayChart == 'size-chart-wetsuits') {
      this.enable();
      if (this.table) this.table.classList.remove('hidden');
      this.chartContainer.classList.add('hidden');
      this.sizeText && this.sizeText.classList.remove('hidden');
      return;
    }
    this.allChartMarkup.forEach((chart) => {
      const id = chart.getAttribute('id');
      if (id == this.displayChart) {
        this.disable();
        if (this.table) this.table.classList.add('hidden');
        this.chartContainer.classList.remove('hidden');
        chart.classList.remove('hidden');
        this.chartContainer.textContent = '';
        this.chartContainer.appendChild(chart);
      } else {
        chart.classList.add('hidden');
      }
    });
    this.sizeText && this.sizeText.classList.add('hidden');
  }

  enable() {
    this.disabled = false;
    this.feetInput.closest('.find-your-size__info-item').classList.remove('hidden');
    this.inchesInput.closest('.find-your-size__info-item').classList.remove('hidden');
    this.lbsInput.closest('.find-your-size__info-item').classList.remove('hidden');
    this.classList.remove('controls--disabled');
    this.feetInput.removeAttribute('disabled');
    this.inchesInput.removeAttribute('disabled');
    this.lbsInput.removeAttribute('disabled');
    this.submitButton.closest('.find-your-size__info-item').classList.remove('hidden');
    this.submitButton.removeAttribute('disabled');
    this.genderInputs.forEach((input) => {
      input.removeAttribute('disabled', true);
      input.closest('.find-your-size__info-item').classList.remove('hidden');
    });
  }

  disable() {
    this.disabled = true;
    this.feetInput.closest('.find-your-size__info-item').classList.add('hidden');
    this.inchesInput.closest('.find-your-size__info-item').classList.add('hidden');
    this.lbsInput.closest('.find-your-size__info-item').classList.add('hidden');
    this.classList.add('controls--disabled');
    this.feetInput.setAttribute('disabled', true);
    this.inchesInput.setAttribute('disabled', true);
    this.lbsInput.setAttribute('disabled', true);
    this.submitButton.closest('.find-your-size__info-item').classList.add('hidden');
    this.submitButton.setAttribute('disabled', true);
    this.genderInputs.forEach((input) => {
      input.setAttribute('disabled', true);
      input.closest('.find-your-size__info-item').classList.add('hidden');
    });
  }

  onKeyUp(e) {
    if (this.disabled) {
      e.preventDefault();
      return;
    }
    this.feetValue = this.feetInput.value;
    this.inchesValue = this.inchesInput.value;
    this.lbsValue = this.lbsInput.value;
    //if (this.feetValue && this.inchesValue && this.lbsValue) this.findMatch();
  }

  findMatch() {
    if (this.errorMessage) this.errorMessage.classList.add('hidden');
    this.activeRow = [];
    if (!this.feetValue || !this.inchesValue || !this.lbsValue) return;
    let height =
      parseInt(this.inchesValue, 10) > 0
        ? parseInt(this.feetValue + this.inchesValue, 10)
        : parseInt(this.feetValue, 10);
    if (this.feetValue > 6 || (this.inchesValue > 7 && this.feetValue == 6)) height = 67;
    const postData = {
      height: height,
      weight: parseInt(this.lbsValue, 10),
      gender: this.gender === 'Mens' ? 'M' : 'F'
    };
    this.loader.classList.remove('hidden');
    fetch('https://us-central1-blue-seventy.cloudfunctions.net/getChartSize', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(postData)
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.error || !response.size) {
          this.activeRow = [];
          this.updateFits();
          this.noMatchFound();
          return;
        }
        this.activeRow = response.size.replace(/\s/g, '').toLowerCase().split('/');
        this.updateFits();
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.loader.classList.add('hidden');
      });
  }

  updateFits() {
    let comfortFit =
      this.activeRow && this.activeRow.length > 1
        ? this.activeRow[1]
        : this.activeRow && this.activeRow[0]
        ? this.activeRow[0]
        : null;
    let raceFit = this.activeRow && this.activeRow.length > 1 ? this.activeRow[0] : null;
    // Endpoint data is not consistent with our charts when returning "S" sizes
    if (comfortFit === 's') {
      if (this.gender === 'men') {
        comfortFit = 'sm';
      } else {
        comfortFit = 'ws';
      }
    }
    if (raceFit === 's') {
      if (this.gender === 'men') {
        raceFit = 'sm';
      } else {
        raceFit = 'ws';
      }
    }
    this.rows.forEach((row, index) => {
      row.classList.remove('performance-fit');
      row.classList.remove('comfort-fit');
      row.classList.remove('your-fit');
      if (typeof this.activeRow === typeof undefined || this.activeRow === null) return;
      const header = row.querySelector('.size-chart__grid-block--header');
      if (!header) return;
      const size = header.textContent.toLocaleLowerCase();
      if (size === comfortFit) {
        if (raceFit) {
          row.classList.add('comfort-fit');
        } else {
          row.classList.add('your-fit');
        }
      } else if (size === raceFit) {
        row.classList.add('performance-fit');
      }
    });
  }

  noMatchFound() {
    if (this.errorMessage) this.errorMessage.classList.remove('hidden');
  }
}

customElements.define('find-your-size', FindYourSize);

class YourPerfectSize extends HTMLElement {
  constructor() {
    super();
    this.queryFeet = getUrlParameters('originalFeet');
    this.queryInches = getUrlParameters('originalInches');
    this.queryWeight = getUrlParameters('originalWeight');
    this.queryGender = getUrlParameters('filter.v.m.p80.gender');
    if (!this.queryFeet || !this.queryInches || !this.queryWeight || !this.queryGender) {
      this.classList.add('hidden');
      return;
    }
    this.raceFit = this.querySelector('[data-race-fit]');
    this.comfortFit = this.querySelector('[data-comfort-fit]');
    this.fitDescriptionText = this.querySelector('[data-fit-text]');
    this.comfortFitText = window.fitStrings.comfortFit;
    this.raceFitText = window.fitStrings.raceFit;
    if (!this.raceFit || !this.comfortFit || !this.raceFitText || !this.comfortFitText || !this.fitDescriptionText) {
      this.classList.add('hidden');
      return;
    }
    this.findSize();
  }

  findSize() {
    let height =
      parseInt(this.queryInches, 10) > 0
        ? parseInt(this.queryFeet + this.queryInches, 10)
        : parseInt(this.queryFeet, 10);
    if (this.queryFeet > 6 || (this.queryInches > 7 && this.queryFeet == 6)) height = 67;
    const postData = {
      height: height,
      weight: parseInt(this.queryWeight, 10),
      gender: this.queryGender === 'Mens' ? 'M' : 'F'
    };
    fetch('https://us-central1-blue-seventy.cloudfunctions.net/getChartSize', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(postData)
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.error || !response.size) {
          this.activeRow = [];
          this.classList.add('hidden');
          return;
        }
        this.activeRow = response.size.replace(/\s/g, '').toLowerCase().split('/');
        this.updateFits();
      })
      .catch((error) => {
        console.error(error);
      });
  }

  updateFits() {
    let comfortFit = this.activeRow.length > 1 ? this.activeRow[1] : this.activeRow[0];
    let raceFit = this.activeRow.length > 1 ? this.activeRow[0] : null;
    // Endpoint data is not consistent with our charts when returning "S" sizes
    if (comfortFit === 's') {
      if (this.queryGender === 'Mens') {
        comfortFit = 'sm';
      } else {
        comfortFit = 'ws';
      }
    }
    if (raceFit === 's') {
      if (this.queryGender === 'Mens') {
        raceFit = 'sm';
      } else {
        raceFit = 'ws';
      }
    }
    if (comfortFit) {
      this.comfortFit.classList.remove('hidden');
      this.comfortFit.textContent = `${comfortFit}`;
      this.classList.remove('hidden');
    }
    if (raceFit) {
      this.raceFit.classList.remove('hidden');
      this.raceFit.textContent = `${raceFit} or`;
      this.fitDescriptionText.classList.remove('hidden');
    }
  }
}

customElements.define('your-perfect-size', YourPerfectSize);

class ScrollMenu extends HTMLElement {
  constructor() {
    super();

    const header = document.querySelector('.header-wrapper');
    const announcement = document.querySelector('announcement-bar');
    const defaultOffset = 80;
    const offsetHeader = header ? header.clientHeight : defaultOffset;
    const offsetBar = announcement ? announcement.clientHeight : defaultOffset;
    const hasSectionOffset = !this.querySelector('[data-section-offset]') ? offsetBar : 0;

    this.button = this.querySelector('button');
    if (!this.button) {
      this.classList.add('hidden');
      return;
    }
    this.target = this.button.getAttribute('data-target-id');
    this.target = document.getElementById(this.target);
    if (!this.target) {
      this.classList.add('hidden');
      return;
    }

    this.classList.remove('hidden');

    this.offset = offsetHeader + hasSectionOffset;
    this.toggles = this.querySelectorAll('.scroll-menu__toggle');

    this.toggles.forEach((toggle) => toggle.addEventListener('click', this.toggleScroll.bind(this)));
  }

  offsetTarget(target) {
    if (!target) return;
    const element = document.getElementById(target);
    if (!element) return;
    return element.getBoundingClientRect().top + document.documentElement.scrollTop - this.offset;
  }

  toggleScroll(event) {
    if (!event) return;
    event.preventDefault();
    const target = event.currentTarget.dataset.targetId;
    const topOffset = this.offsetTarget(target);
    if (!topOffset) return;
    scrollTo({top: topOffset, behavior: 'smooth'});
    this.removeSiblingsClass();
    event.currentTarget.classList.add('active');
  }

  removeSiblingsClass() {
    for (var i = 0; i < this.toggles.length; i++) {
      this.toggles[i].classList.remove('active');
    }
  }
}

customElements.define('scroll-menu', ScrollMenu);
